import { render, staticRenderFns } from "./NoteEdit.vue?vue&type=template&id=8d6c46fe"
import script from "./NoteEdit.vue?vue&type=script&lang=ts"
export * from "./NoteEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports